module.exports = __webpack_public_path__ + "static/img/move-dot.7d543486.svg";